/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pw_strength_strong = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strong`)
};

const es_pw_strength_strong = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuerte`)
};

const de_pw_strength_strong = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stark`)
};

const nl_pw_strength_strong = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sterk`)
};

const fr_pw_strength_strong = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fort`)
};

const it_pw_strength_strong = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forte`)
};

const pt_br2_pw_strength_strong = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forte`)
};

const pt_pw_strength_strong = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forte`)
};

const ja_pw_strength_strong = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`強い`)
};

const zh_pw_strength_strong = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`强`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pw_strength_strong = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pw_strength_strong(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pw_strength_strong", locale)
	if (locale === "en") return en_pw_strength_strong(inputs)
	if (locale === "es") return es_pw_strength_strong(inputs)
	if (locale === "de") return de_pw_strength_strong(inputs)
	if (locale === "nl") return nl_pw_strength_strong(inputs)
	if (locale === "fr") return fr_pw_strength_strong(inputs)
	if (locale === "it") return it_pw_strength_strong(inputs)
	if (locale === "pt-BR") return pt_br2_pw_strength_strong(inputs)
	if (locale === "pt") return pt_pw_strength_strong(inputs)
	if (locale === "ja") return ja_pw_strength_strong(inputs)
	return zh_pw_strength_strong(inputs)
};